import axios from "../../index";
import api from "./python.api";

export default {
  /**
   * 查询代码模式的积木菜单
   * @params null
   */
   getCodeBlockList(data = {}) {
    return axios.post(api.getCodeBlockList, data);
  },
  /**
   * 根据积木id查询积木菜单详情  
   * @params blockId 积木id 
   */
   getCodeBlockInfoById(data = {}) {
    return axios.post(api.getCodeBlockInfoById, data);
  },
  
};
